import React from 'react'
import "./setting.css"
import Navbars from '../Navbars'
import Sidebar from '../profile/Sidebar'
import down from "../assets/down.png"
import del from "../assets/del.png"

function Setting() {
    return (<>
        <div className='conatiner-fluid' style={{ backgroundColor: "#F5F5F5" }}>
            <Navbars />
            <div className='d-flex gap-5 pe-3 main_div'>
                <Sidebar />
                <div className='inner_div  pt-2 ps-4 pe-4 mb-3 pb-3 mb-3' style={{ backgroundColor: "white",width:"100%",marginTop:"85px" }}>
                    <p className='feed_heading'>Settings</p>
                    <p className='feed1_heading mt-5'>Posts</p>
                    <div className='row'>
                        <div className='col-lg-8 col-md-12 col-sm-12'>
                            <div className='row'>
                                <div className='col-lg-6 col-md-6 col-sm-12'>
                                    <p className='grid_heading1'>Sync Posts</p>
                                    <p className='grid_heading2'>Import and sync posts published outside 888Ads
                                        Last Synced: 3 hours ago</p>
                                </div>
                                <div className='col-lg-6 col-md-6 col-sm-12'>
                                    <button className='grid_btn'>Sync Posts</button>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-lg-6 col-md-6 col-sm-12'>
                                    <p className='grid_heading1'>Auto Sync</p>
                                    <p className='grid_heading2'>By checking these options, 888Ads will automatically
                                        import posts and media from social accounts</p>
                                </div>
                                <div className='col-lg-6 col-md-6 col-sm-12'>
                                    <div className='d-flex gap-2 align-items-center mt-4'>
                                        <input className='radio_input' type="radio" />
                                        <p className='grid_heading3'>Automatically sync posts</p>
                                    </div>
                                    <div className='d-flex gap-2 align-items-center mt-3'>
                                        <input className='radio_input' type="radio" />
                                        <p className='grid_heading3'>Add media from synced to the Media Library</p>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-lg-6 col-md-6 col-sm-12'>
                                    <p className='grid_heading1'>Duplicate Settings</p>
                                    <p className='grid_heading2'>Copy this account’s posting schedule etc to other accounts</p>
                                </div>
                                <div className='col-lg-6 col-md-6 col-sm-12'>
                                    <button className='grid_btn'>Duplicate Settings</button>
                                </div>
                            </div>
                            <p className='setting_text'>Time Settings</p>
                          
                            <div className='row'>
                                <div className='col-lg-6 col-md-6 col-sm-12'>
                                    <p className='grid_heading1'>Time zone</p>
                                    <p className='grid_heading2'>Select your timezone</p>
                                </div>
                                <div className='col-lg-6 col-md-6 col-sm-12 pt-4'>
                                    <div style={{ position: "relative", maxWidth: "600px" }}>
                                        <input className='input2 w-100' placeholder='Asia/Japan' />
                                        <div style={{ position: "absolute", top: "5px", right: "10px" }}>
                                            <img src={down} />
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-lg-6 col-md-6 col-sm-12'>
                                    <p className='grid_heading1'>Time Format</p>
                                    <p className='grid_heading2'>Select your time format</p>
                                </div>
                                <div className='col-lg-6 col-md-6 col-sm-12 pt-4'>
                                    <div style={{ position: "relative", maxWidth: "600px" }}>
                                        <input className='input2 w-100' placeholder='24-hr format' />
                                        <div style={{ position: "absolute", top: "5px", right: "10px" }}>
                                            <img src={down} />
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-lg-6 col-md-6 col-sm-12'>
                                    <p className='grid_heading1'>First day of weak</p>
                                    <p className='grid_heading2'>Copy this account’s posting schedule etc to other accounts</p>
                                </div>
                                <div className='col-lg-6 col-md-6 col-sm-12 pt-4'>
                                    <div style={{ position: "relative", maxWidth: "600px" }}>
                                        <input className='input2 w-100' placeholder='Monday' />
                                        <div style={{ position: "absolute", top: "5px", right: "10px" }}>
                                            <img src={down} />
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-lg-6 col-md-6 col-sm-12'>
                                    <p className='grid_heading1'>Start Day</p>
                                    <p className='grid_heading2'>When does your day start?</p>
                                </div>
                                <div className='col-lg-6 col-md-6 col-sm-12 pt-4'>
                                    <div style={{ position: "relative", maxWidth: "600px" }}>
                                        <input className='input2 w-100' placeholder='00:00 (midnight)' />
                                        <div style={{ position: "absolute", top: "5px", right: "10px" }}>
                                            <img src={down} />
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-lg-6 col-md-6 col-sm-12'>
                                    <p className='grid_heading1'>Language</p>
                                    <p className='grid_heading2'>Select your language</p>
                                </div>
                                <div className='col-lg-6 col-md-6 col-sm-12 pt-4'>
                                    <div style={{ position: "relative", maxWidth: "600px" }}>
                                        <input className='input2 w-100' placeholder='English' />
                                        <div style={{ position: "absolute", top: "5px", right: "10px" }}>
                                            <img src={down} />
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-lg-6 col-md-6 col-sm-12'>
                                    <p className='grid_heading1'>Delete Account</p>
                                    <p className='grid_heading2'>Delete your account and all your data from 888 Ads. If you have
                                        an active paid subscription with us, it will be automatically
                                        cancelled.</p>
                                </div>
                                <div className='col-lg-6 col-md-6 col-sm-12 pt-4'>
                                    <div className='d-flex gap-2 align-items-center pt-5'>
                                        <img src={del} />
                                        <p className='delete_text'>Delete Account</p>

                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>



                </div>

            </div>
        </div>





    </>

    )
}

export default Setting